import './App.css';
import {
  BrowserRouter,
  Route,
  Routes,
  Link
} from 'react-router-dom'
import SignIn from './components/authentication/SignIn';
import SignUp from './components/authentication/SignUp';
import Home from './components/Home/Home';
import React, { useState } from 'react';
import Blog from './components/Blog/Blog';

function App() {

  const isLoggedIn = localStorage.getItem('isLoggedIn');
  const [navigate, setNavigate] = useState(isLoggedIn ? true : false);
  const [email, setEmail] = useState(localStorage.getItem('email'));

  function handleLogin() {
    localStorage.setItem('isLoggedIn', true);
    setNavigate(true);
  }

  function handleLogout() {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token');
    localStorage.removeItem(email);
    setNavigate(false);
  }

  return (
    <main>
      <BrowserRouter>
        <Routes>
          {navigate === false ?
            <Route path='/' element={<SignIn email={setEmail} handleLogin={handleLogin} />} />
            :
            <>
            <Route path='/' element={<Home email={email} handleLogout={handleLogout} />} /> 
            </>
          }
          <Route path='/signup' element={<SignUp />} />
          {navigate ? <Route path='/blog/:id' handleLogout={handleLogout} element={<Blog email={email} />} /> : <Route path='/blog' element={<div className='m-5'> Page is not available, you need to first sign in <Link to='/' className='ms-5 text-primary'> SignIn</Link> </div>} />}

        </Routes>
      </BrowserRouter>
    </main>
  );
}

export default App;



